import { UntypedFormGroup } from '@angular/forms';

/**
 * Labels of the conflict sources that currently hold a value, e.g. "CO#" and
 * "Customer". Every source feeding a target's default is named, not just the
 * one the user changed, and an empty source is never named as a driver.
 */
export function liveConflictSourceLabels(
  sources: Array<{ formControlName: string; label?: string }> | undefined,
  form: UntypedFormGroup | undefined
): Array<string> {
  return (sources ?? [])
    .filter((meta) => form?.controls?.[meta.formControlName]?.value != null)
    .map((meta) => meta.label)
    .filter((label): label is string => !!label);
}
